import { useQueries } from '@tanstack/react-query';

import { useRelationshipTasks } from 'services/repositories/tasks/tasks';
import { RelationshipV2, TaskDTO } from 'support/types';

export const useTasksByRelationshipId = (relationships: Array<RelationshipV2>) => {
  const tasksPendingRelationships = relationships.filter((rel) => rel.status === 'TASKS_PENDING');

  const tasksQueries = useQueries({
    queries: tasksPendingRelationships.map((rel) => useRelationshipTasks.getFetchOptions({ relationshipId: rel.id })),
  });

  const tasksByRelationshipId: Record<string, Array<TaskDTO>> = {};
  tasksPendingRelationships.forEach((rel, index) => {
    const queryData = tasksQueries[index]?.data?.data;
    if (queryData) {
      tasksByRelationshipId[rel.id] = queryData;
    }
  });

  return tasksByRelationshipId;
};
